export default "__VITE_ASSET__9ONgnaCj__"